export interface PageLink {
  section: string;
  project?: string;
  part?: string;
  tenant?: string;
}

// Fragments survive sign-in without sending workspace identifiers to the server.
export function readPageLink(hash = location.hash): PageLink | undefined {
  if (!hash.startsWith("#studio?")) return;
  const query = new URLSearchParams(hash.slice(8));
  const section = query.get("section");
  if (!section || !/^[a-z][a-z-]*$/.test(section)) return;
  return {
    section,
    project: query.get("project") || undefined,
    part: query.get("part") || undefined,
    tenant: query.get("tenant") || undefined,
  };
}

export function pageLinkHash(link: PageLink) {
  const query = new URLSearchParams({ section: link.section });
  if (link.project) query.set("project", link.project);
  if (link.project && link.part) query.set("part", link.part);
  if (link.tenant) query.set("tenant", link.tenant);
  return `#studio?${query}`;
}
